import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        padding: '40px',
        fontSize: '26px',
        color: theme.palette.black,
        fontWeight: 'bold',
    },
    dashboardTitle: {
        fontSize: '24px',
        color: theme.palette.black,
        fontWeight: 'bold',
        marginBottom: '12px',
    },
    textInput: {
        width: '100%',
        position: 'relative',

        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E5E9ED',
        },
    },
    textInputWrapper: {
        // margin: '12px',
        // marginLeft: 0,

        '& .MuiOutlinedInput-root': {
            backgroundColor: '#E5E9ED',
        },

        '& .Mui-focused': {
            backgroundColor: '#F7F7FA !important',
        },

        [theme.breakpoints.down('md')]: {
            margin: '8px 0',
        },
    },
    textAreaWrapper: {
        // margin: '12px 0',
        // marginRight: '110px',

        '& .MuiOutlinedInput-root': {
            backgroundColor: '#E5E9ED',
        },

        '& .Mui-focused': {
            backgroundColor: '#F7F7FA !important',
        },

        [theme.breakpoints.down('md')]: {
            margin: '8px 0',
        },
    },
    buttonSave: {
        backgroundColor: '#EBA900',
        color: 'white',
        width: '120px',
        margin: '10px',
        marginLeft: 0,
    },
    buttonCancel: {
        color: '#EBA900',
        border: '1px solid #EBA900',
        width: '120px',
        margin: '10px',

        '&:hover': {
            color: '#EB7F00',
            border: '1px solid #EB7F00',
        },
    },
    textInputWrapperSpace: {
        [theme.breakpoints.down('md')]: {
            height: 0,
        },
    },
    selectLocation: {
        position: 'relative',
        '& svg': {
            right: '24px',
        },
    },
    locationRequire: {
        position: 'absolute',
        color: 'red',
        fontSize: 'initial',
        top: '18px',
        right: '14px',
        zIndex: 1,
    },
}));
